/**
 * @author Alexey Tatarinov <tatarinov@shogo.ru>
 * @link https://github.com/shogodev/argilla/
 * @copyright Copyright &copy; 2003-2014 Shogo
 * @license http://argilla.ru/LICENSE
 *
 * Пример использования:
 * $this->basket->ui->addAfterAjaxScript(new CJavaScriptExpression("
 *   if( action == 'add' )
 *   {
 *     image = element.closest('.product, .product-main-block, .product-details-data').find('.animate-image');
 *     $('.hd-basket').addInCollection(image);
 *   }
 * "));
 *
 * В css прописать:
 *
 * .moving-to-basket {
 *   transition:all .75s ease;
 *   z-index: 10000;
 * }
 */

;(function($) {

  $.fn.addInCollection = function(pic) {

    this.move = function(pic, targetBlock) {

      if ( pic == undefined || pic.length == 0 )
        return;

      if(targetBlock == undefined || targetBlock.length == 0)
        return;

      var clonedPic = pic.clone().css({
        position: 'fixed',
        left: pic.offset().left - $(window).scrollLeft(),
        top: pic.offset().top - $(window).scrollTop(),
        height: pic.height(),
        width: pic.width()
      }).addClass('moving-to-basket');
      $('body').append(clonedPic);

      var targetPos = { top: targetBlock.offset().top - $(window).scrollTop(), left: targetBlock.offset().left - $(window).scrollLeft() };
      clonedPic.css({
        top: targetPos.top,
        left: targetPos.left,
        opacity: 0
      }).addClass('scale');

      setTimeout(function(){
        clonedPic.remove();
      }, 500)
    };

    this.move(pic, this);

    return this;
  };

})(jQuery);
